/**
 * Branded unsubscribe confirmation page.
 *
 * Mounted at /unsubscribe?token=<HMAC-token> (public, no login required).
 * On mount it POSTs /api/unsubscribe to honour the token server-side, then
 * shows a branded success or failure card.
 */
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const wrap = {
  maxWidth: 480,
  margin: "72px auto",
  padding: "0 20px",
  fontFamily: "system-ui, -apple-system, sans-serif",
  color: "#1c2a1f",
};
const card = {
  background: "#fff",
  border: "1px solid #e4ede4",
  borderRadius: 18,
  padding: "36px 32px",
  boxShadow: "0 6px 28px rgba(20, 50, 20, 0.07)",
  textAlign: "center",
};
const logo = {
  display: "block",
  margin: "0 auto 28px",
  height: 44,
};
const heading = (ok) => ({
  fontSize: 22,
  fontWeight: 700,
  color: ok ? "#1B5E20" : "#b71c1c",  // brand-color-ok
  margin: "0 0 12px",
});
const body = {
  fontSize: 15,
  lineHeight: 1.6,
  color: "#3a4a3a",
  margin: "0 0 20px",
};
const subtle = {
  fontSize: 13,
  color: "#789378",
};

export default function UnsubscribePage() {
  const { search } = useLocation();
  const token = new URLSearchParams(search).get("token") || "";

  const [status, setStatus] = useState("loading"); // loading | ok | error

  useEffect(() => {
    if (!token) {
      setStatus("error");
      return;
    }
    fetch(`/api/unsubscribe?token=${encodeURIComponent(token)}`, {
      method: "POST",
    })
      .then((r) => {
        setStatus(r.ok ? "ok" : "error");
      })
      .catch(() => setStatus("error"));
  }, [token]);

  const ok = status === "ok";
  const loading = status === "loading";

  return (
    <div style={wrap}>
      <div style={card}>
        <img
          src={`${process.env.PUBLIC_URL || ""}/logo-green-gold.png`}
          alt="Vishal Sanjivini"
          style={logo}
        />

        {loading && (
          <p style={body}>Processing your request…</p>
        )}

        {!loading && (
          <>
            <h1 style={heading(ok)}>
              {ok ? "You're unsubscribed" : "Link not valid"}
            </h1>
            <p style={body}>
              {ok
                ? "You will no longer receive notification emails from Vishal Sanjivini MACS. Security and OTP messages are unaffected."
                : "This unsubscribe link is invalid or has already been used. Please use the link from a recent email."}
            </p>
            {ok && (
              <p style={subtle}>
                You can re-enable email notifications any time from{" "}
                <strong>Settings → Notifications</strong> in the app.
              </p>
            )}
          </>
        )}
      </div>
    </div>
  );
}
